import React from "react";
import { Container, Row, Col } from "reactstrap";
import { Helmet } from "react-helmet";
import Footer from '../../../components/Footer';
import { ArticleContent } from "../../../style/Blog";
import CardClotere1 from "../../CardClotere1";
import CardClotereSidebarQuestion from "../../CardClotereSidebarQuestion";
import HeaderPost from '../../HeaderPost';
import ArticlesSimilaires from "../../ArticlesSimilaires";
import PrendreRdv from "../../../leadPage/prendreRdv";
import FaqVendeur from "../../FaqVendeur";
import PlusLoinVendeur from "../../components/PlusLoinVendeur";
import { Link } from 'react-router-dom';

function ArticleFraisVenteImmo() {
  return (
    <>
      <Helmet>
        <title>Quels frais prévoir pour la vente d’un bien immobilier ?</title>
        <meta name="robots" content="index,follow" />
        <meta name="googlebot" content="index,follow" />
        <meta name='description' content="Découvrez tous les frais à anticiper lors de la vente de votre bien immobilier : diagnostics, agence, notaire, plus-value..." />
        <meta property="og:url" content="https://clotere.fr/blog/frais-vente-immobilier" />
        <meta property="og:site_name" content="Clotere" />
        <meta property="og:image" content="https://clotere.fr/facebook-share-webp" />
        <meta property="og:type" content="website" />
      </Helmet>
  
      <HeaderPost titre="Quels sont les frais à prévoir lors de la vente d’un bien immobilier ?" breadlink1="/blog/immobilier" namelink1="Vente immobilière" namelinkActive="Frais de vente immobilier" />
  
      <div>
        <ArticleContent>
          <section className="content">
            <Container>
              <Row>
                <Col className="col-sm-9 col-xs-12 article">
                  <p>
                    La vente d'un bien immobilier ne se limite pas à la simple transaction entre le vendeur et l'acheteur. Elle implique des frais annexes qu'il est important d'anticiper. Le notaire, acteur clé de cette opération, vous accompagne dans l’évaluation et le règlement de ces frais.
                  </p>
  
                  <h2>1. Les frais d'agence immobilière</h2>
                  <p>
                    Si vous vendez par l’intermédiaire d’une agence, prévoyez une commission comprise entre 3 % et 8 % du prix de vente. Cette charge peut être supportée par l’une ou l’autre des parties selon le mandat signé.
                  </p>
                  <blockquote className="blog-quote">Astuce Clotere : Négociez les frais d’agence avant signature. La concurrence peut faire baisser les coûts.</blockquote>
  
                  <h2>2. Les frais de diagnostics immobiliers</h2>
                  <p>
                    Avant la signature d’un compromis de vente, le vendeur doit fournir un Dossier de Diagnostic Technique (DPE, amiante, plomb, gaz, etc.). Comptez entre 300 € et 800 € en fonction du bien.
                  </p>
                  <blockquote className="blog-quote">À savoir : Ces diagnostics sont obligatoires et doivent être prêts avant la vente.</blockquote>
  
                  <h2>3. Les frais de notaire</h2>
                  <p>
                    Même si la majorité des frais de notaire sont à la charge de l’acquéreur, certaines formalités peuvent générer des frais à votre charge (copies, frais d’envoi…).
                  </p>
                  <ul>
                    <li>• Droits de mutation (versés à l’État)</li>
                    <li>• Frais administratifs</li>
                    <li>• Émoluments du notaire</li>
                  </ul>
                  <blockquote className="blog-quote">Astuce Clotere : Demandez une estimation des frais notariaux dès le début.</blockquote>
  
                  <h2>4. Les frais de copropriété</h2>
                  <p>
                    Pour un bien en copropriété, des documents à fournir à l’acheteur (règlement, PV d’AG, etc.) peuvent être facturés par le syndic.
                  </p>
                  <blockquote className="blog-quote">À savoir : Anticipez la demande des documents pour éviter les retards.</blockquote>
  
                  <h2>5. La taxe sur la plus-value immobilière</h2>
                  <p>
                    Si le bien n’est pas votre résidence principale, une plus-value peut être imposable :
                  </p>
                  <ul>
                    <li>• 19 % d’impôt sur le revenu</li>
                    <li>• 17,2 % de prélèvements sociaux</li>
                  </ul>
                  <p>
                    Le notaire se charge du calcul et du règlement. Exonération possible après 30 ans de détention.
                  </p>
  
                  <h2>Conclusion : Anticipez pour mieux vendre</h2>
                  <p>
                    De l’agence au notaire, en passant par les diagnostics et la fiscalité, la vente d’un bien nécessite une bonne préparation. Clotere vous accompagne pour comprendre et anticiper chaque frais, et vous assure une transaction en toute sérénité.
                  </p>
  
                  <CardClotere1 type="vente" />
  
                  <blockquote className="blog-quote">
                    👉 Besoin d'accompagnement pour vendre votre bien ? <Link to="/onboard/vente">Commencez ici</Link>
                  </blockquote>

                  <PlusLoinVendeur/>
                </Col>
  
                <div className="col-sm-3 col-xs-0 sidebar hidden sm:block">
                <CardClotereSidebarQuestion />
              </div>

              <div className="col-xs-0 sm:hidden">
                <CardClotereSidebarQuestion />
              </div>
              </Row>
            </Container>
          </section>
        </ArticleContent>
        <FaqVendeur/>
        <ArticlesSimilaires title="Articles similaires" type="immobilier" />
        <PrendreRdv />
        <Footer />
      </div>
    </>
  );
  
}

export default ArticleFraisVenteImmo;